// removed by extract-text-webpack-plugin
module.exports = {"root":"_rTQg2","content":"_3EQ_u","buttons":"_NFP1v"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Dialog/Dialog.scss
// module id = 1573
// module chunks = 1